"use strict";
// (C) 2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogListLoading = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var LoadingMask_1 = require("../../LoadingMask");
exports.DialogListLoading = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("div", { "aria-label": "dialog-list-loading", className: classnames_1.default("gd-dialog-list-loading s-dialog-list-loading", className) },
        react_1.default.createElement(LoadingMask_1.LoadingMask, { size: "large" })));
};
//# sourceMappingURL=DialogListLoading.js.map